import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ScoreStatusForm from '../../../components/forms/ScoreStatusForm';
import { useCreateScoreStatus } from '../../../hooks/useScoreStatusApi';
import { useNavigate } from 'react-router-dom';
import { ScoreStatusDTO } from '../../../services/apiClient';

const ScoreStatusCreate: React.FC = () => {
  const createMutation = useCreateScoreStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Score Statuses', href: '/admin/scorestatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ScoreStatusDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/scorestatuses');
    } catch (error) {
      console.error('Error creating ScoreStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/scorestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ScoreStatus.Edit"
    >
        <ScoreStatusForm
          initialValues={{} as ScoreStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/scorestatuses')}
        />
    </AdminLayout>
  );
};

export default ScoreStatusCreate;
